import React from "react"
import { get } from "lodash"

import data from "../../../../../data"
import Link from "../../components/Link"
import "./tables.less"

/**
 * 
 */

const _parenRegex = /\(([^)]+)\)/

const reservationTime = r => {
  let day = r.day || get(r, "formData.dayString", "")
  if (day.includes("(")) { // :)
    day = _parenRegex.exec(day)[1]
  }

  return `${day} ${r.shift || get(r, "formData.time", "")}`
}

type Props = {
  reservations: any,
  partnerMode: boolean
}

class ReservationsTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortKey: "timestamp"
    }
  }

  
  props: Props

  render() {
    return (
      <ol style={{ margin: 40 }}>
        {
          data.partners
            .map(({ _id, name, key }) => (
              <li key={_id}>
                <Link to={`/partner/${name}?key=${key}`}>
                  Partner: 
                  {' '}
                  {name}
                </Link>
              </li>
            ))
        }
      </ol>
      
    )
  }
}

export default ReservationsTable



// WEBPACK FOOTER //
// ./src/app/admin/components/tables/PartnerList.jsx